import { FormControl, FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import { type AddOrEditAnnualPlanMeetingRequest } from '../../../models/requestObjects/AnnualPlanRequestObjects'
import { Modal } from '../../customComponents/Modal'
import { useState } from 'react'

interface Props {
  meeting: AddOrEditAnnualPlanMeetingRequest
  onClose: (isUpdate: boolean, submittedForm: AddOrEditAnnualPlanMeetingRequest, isTracking: boolean) => void
  onCancel: () => void
}

export function TrackMeetingModal (props: Props): JSX.Element {
  const [formValues, setFormValues] = useState<AddOrEditAnnualPlanMeetingRequest>(props.meeting)
  const [wasCompleted, setMeetingWasCompleted] = useState<boolean | null>(props.meeting.wasCompleted ?? null)
  const handleFieldUpdate = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.name === 'wasCompleted') {
      setMeetingWasCompleted(e.target.value === 'true')
    }

    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    })
  }

  return <Modal
    title='RCN Meeting Tracking'
    open={true}
    width='450px'
    data-testid='annualPlanningTeamModal'
    onClose={props.onCancel}
    onConfirm={() => { props.onClose(true, formValues, true) }}
    buttonClassName='modal-button'
    confirmButtonText='Save Changes'
    confirmButtonClassName='modal-confirm-button'
    cancelButtonText='Cancel'
    bodyContent={ <>
      <Typography variant='h5' sx={{ my: '.5em' }}>Meeting Info</Typography>
      <FormControl>
        <FormLabel id='demo-radio-buttons-group-label'>Was this meeting held?</FormLabel>
        <RadioGroup
          row
          value={wasCompleted == null ? null : wasCompleted ? 'true' : 'false'}
          onChange={handleFieldUpdate}
          aria-labelledby='demo-radio-buttons-group-label'
          defaultValue={wasCompleted == null ? null : wasCompleted ? 'true' : 'false'}
          name='wasCompleted'
        >
          <FormControlLabel data-testid='meetingHeldOption' value='true' control={<Radio />} label='Yes' />
          <FormControlLabel data-testid='meetingNotHeldOption' value='false' control={<Radio />} label='No' />
        </RadioGroup>
      </FormControl>
      <Typography variant='h5' sx={{ my: '.5em' }}>Budget</Typography>
      <Typography variant='body1'>How much funding was actually used?</Typography>
      <TextField
        sx={{ mt: '.75em', width: '250px' }}
        onChange={handleFieldUpdate}
        label='Enter Amount'
        data-testid='actualBudgetAmount'
        InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
        name='actualBudgetAmount'
        variant='filled'
        value={formValues.actualBudgetAmount}
      />
    </>
    }
  />
}
